import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-[600] tw-leading-[130%] title" }
const _hoisted_4 = { class: "tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-w-full" }
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_7 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_8 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]"
}
const _hoisted_10 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_11 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_12 = { class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title" }
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_14 = {
  key: 1,
  class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title"
}
const _hoisted_15 = { class: "tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_16 = { class: "tw-text-[#878787] tw-font-[500]" }
const _hoisted_17 = {
  key: 0,
  class: "custom-global-skeleton-pulse tw-w-[72px] tw-h-[72px] tw-rounded-[50%]"
}

import { getComponentUiText } from "@/utils/utilities";
import RadialProgressBar from "../prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import { ComputedRef, computed } from "vue";
import {
  TEXT_COLOR_WITH_GRADE_SCORE,
  generateGradeScoreWithCompletedScore,
} from "@/services/assessment";
import store from "@/store";
import { IChecklistMetricsCompletion } from "@/interfaces/assessments/IAssessmentDetails";
import { IChecklistInfoDetail } from "@/interfaces/assessments/IAssessmentDetails";
import AssessmentChecklistStatusTag from "../assessment/assessmentChecklistStatusTag.vue";
import { CHECKLISTSTATUS } from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'completionCard',
  props: {
  isAssessmentDetail: {
    type: Boolean,
    required: false,
    default: false,
  },
  detail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  checklistCompletionProps: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  checklistScoreDetail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  statusDetail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  classStyleContent: {
    type: String,
    default: "",
  },
  classStyleIcon: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const checklistCompletion = computed(
  () => store.state.Assessment.overviewCardData?.completionCard,
);

const checklistMetricsCompletion: ComputedRef<IChecklistMetricsCompletion> =
  computed(() => store.getters["Assessment/getChecklistMetricsCompletion"]);

const checklistInforDetail: ComputedRef<IChecklistInfoDetail> = computed(() => {
  if (props.isAssessmentDetail) {
    const assessment = store.getters["Assessment/getChecklistInforDetailById"](
      props.detail?.checklistId,
    );
    return { ...props.detail, ...assessment };
  }
  return store.getters["Assessment/getChecklistInforDetail"];
});

const isShowRadial = computed(() => {
  return props.isAssessmentDetail
    ? props.statusDetail.checklistStatusId !== CHECKLISTSTATUS.DONE
    : checklistInforDetail.value.checklistStatusId !== CHECKLISTSTATUS.DONE;
});

const percentProgress = computed(() => {
  return props.isAssessmentDetail
    ? props.checklistCompletionProps.checklistCompletionPcnt
    : parseFloat(
        (
          checklistMetricsCompletion.value.checklistCompletionPcnt * 100
        ).toFixed(2),
      );
});

const percentScore = computed(() => {
  const score = props.isAssessmentDetail
    ? props.checklistScoreDetail.checklistScorePcnt
    : checklistCompletion.value.checklistScorePcnt;
  return (score * 100).toFixed(2);
});

const isChecklistInforDetailLoading = computed(() => {
  return Object.keys(checklistInforDetail.value).length === 0;
});

const isChecklistMetricsCompletionLoading = computed(() => {
  return Object.keys(checklistMetricsCompletion.value).length === 0;
});

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", {
    id: `completion-card-${__props.detail?.checklistId}`,
    class: "tw-flex"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'tw-bg-[#FCFCFC] tw-max-h-[112px] tw-min-h-[112px] tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
        __props.classStyleContent,
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-status-1")), 1),
        _createElementVNode("div", null, [
          _createVNode(AssessmentChecklistStatusTag, {
            id: `checklist-status-tag-${__props.isAssessmentDetail ? 'detail' : ''}-${
              __props.detail?.checklistId
            }`,
            "checklist-status": checklistInforDetail.value.checklistStatus,
            "checklist-status-id": checklistInforDetail.value.checklistStatusId,
            "is-loading": 
              props.isAssessmentDetail ? false : isChecklistInforDetailLoading.value
            
          }, null, 8, ["id", "checklist-status", "checklist-status-id", "is-loading"]),
          _createVNode(_component_b_popover, {
            target: `checklist-status-tag-${
              __props.isAssessmentDetail ? 'detail' : ''
            }-${__props.detail?.checklistId}`,
            triggers: "hover",
            placement: "top-start",
            "custom-class": "custom-actions-popover",
            offset: 8,
            delay: {
              show: 0,
              hide: 100,
            },
            onShow: ($event: any) => (true)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(convertUTCTimeToLocalTime)(__props.detail?.checklistStatusDate)) + " " + _toDisplayString(__props.detail?.checklistStatusNotes
                  ? `: ${__props.detail?.checklistStatusNotes}`
                  : ""), 1)
            ]),
            _: 1
          }, 8, ["target"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)("app-component-assessment-title-progress-1")), 1),
          (
              isChecklistMetricsCompletionLoading.value && !props.isAssessmentDetail
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(props.isAssessmentDetail
                ? props.checklistCompletionProps.checklistCompletion
                : checklistMetricsCompletion.value.checklistCompletion) + "/" + _toDisplayString(props.isAssessmentDetail
                ? props.checklistCompletionProps.checklistCompletionMax
                : checklistMetricsCompletion.value.checklistCompletionMax) + " ", 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(percentProgress.value) + "%", 1)
              ]))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-question-type-2-icon-tooltip-score-1",
              )), 1),
          (
              isChecklistMetricsCompletionLoading.value && !props.isAssessmentDetail
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_13))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(props.isAssessmentDetail
                  ? Math.round(+props.checklistScoreDetail?.checklistScore)
                  : Math.round(+checklistCompletion.value?.checklistScore)) + "/" + _toDisplayString(props.isAssessmentDetail
                  ? Math.round(+props.checklistScoreDetail?.checklistScoreMax)
                  : Math.round(+checklistCompletion.value?.checklistScoreMax)) + " ", 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(props.isAssessmentDetail
                    ? (
                        props.checklistScoreDetail?.checklistScorePcnt * 100
                      ).toFixed(1)
                    : (checklistCompletion.value?.checklistScorePcnt * 100).toFixed(
                        1,
                      )) + "%", 1)
                ])
              ]))
        ])
      ])
    ], 2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
        'tw-p-[20px] tw-bg-[#FCFCFC] tw-max-h-[112px] tw-max-w-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        __props.classStyleIcon,
      ])
    }, [
      (isChecklistMetricsCompletionLoading.value && !props.isAssessmentDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
        : (_openBlock(), _createBlock(RadialProgressBar, {
            key: 1,
            class: "d-inline",
            "total-steps": 100,
            "completed-steps": percentProgress.value,
            "is-hide-progress": true,
            "outer-stroke-color": "#48A0FF"
          }, null, 8, ["completed-steps"]))
    ], 2), [
      [_vShow, isShowRadial.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
        'tw-flex tw-items-center tw-justify-center tw-p-[20px] tw-bg-[#ffffff] tw-max-w-[112px] tw-max-h-[112px] tw-rounded-r-md tw-border tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]',
        __props.classStyleIcon,
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["tw-w-[72px] tw-h-[72px] tw-flex tw-items-center tw-justify-center tw-text-[30px] tw-font-[600]", `tw-text-[${
          _unref(TEXT_COLOR_WITH_GRADE_SCORE)[
            _unref(generateGradeScoreWithCompletedScore)(Number(percentScore.value))
          ]
        }]`])
      }, _toDisplayString(_unref(generateGradeScoreWithCompletedScore)(Number(percentScore.value))), 3)
    ], 2), [
      [_vShow, !isShowRadial.value]
    ])
  ], 8, _hoisted_1))
}
}

})